module.exports = __webpack_public_path__ + "img/local_shipping.977def9a.svg";